import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SsoAuthService {


  constructor(private http: HttpClient, private router: Router) { }

  baseUrl = environment.backendBaseUrl;

  /**
   * Validate family code and name
   * Example API: /api/v1/auth/member/fc=005239052700&name=xyz
   */
  validateFamilyCode(familyCode: string, country: string | ''): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/signinFC`;
    const payload = { fc: familyCode, country };
    return this.http.post<any>(url, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).pipe(
      catchError(this.handleError.bind(this))
    );
  }


  validateSerialNoCode(serialNo: string, country: string): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/signinSerialNo`;
    const payload = { serialNo: Number(serialNo), country };

    return this.http.post<any>(url, payload, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }).pipe(
      catchError(this.handleError.bind(this))
    );
  }


  sendOtp(payload: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/signinContact`;
    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  signinEmail(payload: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/signinEmail`;
    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  verifyOtp(payload: any): Observable<any> {

    const url = `${this.baseUrl}/api/v1/auth/verifyOTP`;
    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  verifyPassword(payload: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/verifyPassword`;
    return this.http.post<any>(url, payload).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  authorizeSession(payload: { appId: number | null; codeChallenge: string | null }): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/authorizeSession`;

    const headers: any = {
      'sso-session': localStorage.getItem('sso-session')
    }

    return this.http.post<any>(url, payload, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  logOut(): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/logout`;

    const headers: any = {
      'sso-session': localStorage.getItem('sso-session')
    }

    return this.http.post<any>(url, {}, { headers: headers }).pipe(
      catchError(this.handleError.bind(this))
    )
  }


  getProfileDetails(): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/getProfileDetails`;

    const headers: any = {
      'sso-session': localStorage.getItem('sso-session')
    }

    return this.http.get<any>(url, { headers: headers }).pipe(
      catchError(this.handleError.bind(this))
    )
  }

  findMember(payload: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/findMember`;

    const headers: any = {
      'Content-Type': 'application/json',
      'state-token': sessionStorage.getItem('state_token') || ''
    };

    return this.http.post<any>(url, payload, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  register(payload: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/register`;

    const headers: any = {
      'Content-Type': 'application/json',
      'state-token': sessionStorage.getItem('state_token') || ''
    };

    return this.http.post<any>(url, payload, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }


  createSession(payload: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/createSession`;

    const headers: any = {
      'Content-Type': 'application/json',
      'state-token': sessionStorage.getItem('state_token') || ''
    };

    return this.http.post<any>(url, payload, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }


  createSessionFromSec(payload: { appId: number; codeChallenge: string }): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/createSessionFromSec`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'state-token': sessionStorage.getItem('state_token') || ''
    });

    return this.http.post<any>(url, payload, {
      headers
    }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  sendOtpFc(payload: { fc: string; contactNo: string }): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/sendOTP`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, payload, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  sendOtpSlno(payload: { serialNo: number; contactNo: string }): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/sendOTP`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this.http.post<any>(url, payload, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }


  updateProfile(payload: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/updateProfile`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'sso-session': localStorage.getItem('sso-session') || ''
    });

    return this.http.post<any>(url, payload, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  getPincodeDetails(pincode: string): Observable<any> {
    const url = `${this.baseUrl}/api/v1/geo-data/pincodes/${pincode}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'sso-session': localStorage.getItem('sso-session') || ''
    });

    return this.http.get<any>(url, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  getCountryDetails(appid: number): Observable<any> {
    const url = `${this.baseUrl}/api/v1/geo-data/country/${appid}`;

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'sso-session': localStorage.getItem('sso-session') || ''
    });

    return this.http.get<any>(url, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }


  /**
   * Handle HTTP error
   */
  private handleError(error: HttpErrorResponse) {
    let errorMessage: string = error?.error?.message;
    console.log('**ERROR**', error);
    if (error.status == 401) {
      localStorage.clear();
      this.router.navigate(['/']);
    }
    // if (error.error instanceof ErrorEvent) {
    //   errorMessage = `An error occurred: ${error.error.message}`;
    // }
    // if(error?.message){
    //   errorMessage = error.message;
    // }
    // else if(error?.error?.message){
    //   errorMessage = error.error.message;
    // }
    // else if (error?.error?.error) {
    //   errorMessage = error.error.error;
    // } else if (error.message) {
    //   errorMessage = error.message;
    // }
    // else {
    //   errorMessage = `An unexpected error occured`
    // }
    return throwError(() => ({ message: errorMessage, error }));
  }

  updatePhoneNo(number: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/updateContact`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'sso-session': localStorage.getItem('sso-session') || ''
    });
    return this.http.post<any>(url, number, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  verifyContactNo(number: any): Observable<any> {
    const url = `${this.baseUrl}/api/v1/auth/verifyContactUpdate`;
    const headers = new HttpHeaders({
      'sso-session': localStorage.getItem('sso-session') || ''
    });
    return this.http.post<any>(url, number, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }

  verifyOtpRegister(payload: any): Observable<any> {

    const url = `${this.baseUrl}/api/v1/auth/registerVerify`;
    const headers = new HttpHeaders({
      'state-token': sessionStorage.getItem('state_token_2') || ''
    });
    return this.http.post<any>(url, payload, { headers }).pipe(
      catchError(this.handleError.bind(this))
    );
  }
}
